import { FC } from 'react';
import { useParams } from 'react-router';

import BackButton from 'components/BackButton';
import ErrorCard from 'components/ErrorCard';
import Loader from 'components/Loader';
import ModalProvider from 'components/ModalProvider';
import { ClientModalsProvider } from 'features/Work/hooks/useClientModals';
import * as Layout from 'layouts/ContentLayout';

import { ClientModalProvider } from '../../components/Modals';
import { useGetClient } from '../../hooks/useGetClient';
import ClientInvoicesAndQuotes from './components/ClientInvoicesAndQuotes';
import DetailsHeaderCard from './components/DetailsHeaderCard';
import { Client, ClientDetailsParams } from './types';

const ClientDetails: FC = () => {
  const { clientId } = useParams<ClientDetailsParams>();
  const { client, error, loading, refetch } = useGetClient(clientId);

  if (loading) {
    return <Loader />;
  }

  if (error || !client) {
    return (
      <Layout.Root>
        <Layout.Body>
          <ErrorCard retry={refetch} />
        </Layout.Body>
      </Layout.Root>
    );
  }

  return (
    <ClientModalsProvider>
      <ModalProvider>
        <ClientModalProvider>
          <Layout.Root>
            <Layout.Body size="md">
              <BackButton marginBottom="space-32" />
              <DetailsHeaderCard client={client as Client} />
              <ClientInvoicesAndQuotes clientId={clientId} />
            </Layout.Body>
          </Layout.Root>
        </ClientModalProvider>
      </ModalProvider>
    </ClientModalsProvider>
  );
};

export default ClientDetails;
